import { Box } from '@material-ui/core'
import { useMemo } from 'react'

import {
  LayersConfig,
  LayersViewControl,
} from '@/components/map/layers-view-control'

export interface FailureLayerState {
  name: string
  color: string
  fillColor: boolean
}

interface ControlFillLayersProps {
  layers: FailureLayerState[]
  handleLayerChange: (layerName: string, checked: boolean) => void
}

export function ControlFillLayers({
  layers,
  handleLayerChange,
}: ControlFillLayersProps) {
  const layersConfig = useMemo(
    () =>
      layers.reduce<LayersConfig>((acc, layer) => {
        acc[layer.name] = {
          label: (
            <Box display='flex' gridGap={8} alignItems='center'>
              <Box
                bgcolor={layer.color}
                minWidth={16}
                minHeight={16}
                maxWidth={16}
                maxHeight={16}
                borderRadius={4}
              />
              {layer.name}
            </Box>
          ),
          checked: layer.fillColor,
          disabled: false,
        }
        return acc
      }, {}),
    [layers],
  )

  return (
    <LayersViewControl
      layersConfig={layersConfig}
      onLayerChange={handleLayerChange}
      title={'Preenchimento de camadas'}
      defaultOpen
    />
  )
}
